<template>
  <div class="vue-component-holder">
    <!--[if lt IE 8]>
    <p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="http://browsehappy.com/">upgrade your
      browser</a> to improve your experience.</p>
    <![endif]-->


    <!--    &lt;!&ndash; Page &ndash;&gt;-->
    <!--    <div class="page" data-animsition-in="fade-in" data-animsition-out="fade-out">-->
    <!--      <div class="page-content">-->
    <!--        <div class="page-brand-info">-->
    <!--          <div class="brand">-->
    <!--            <img class="brand-img" src="/static/assets/images/repnode-logo-02.svg" alt="...">-->
    <!--          </div>-->
    <!--          <p class="font-size-20">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod-->
    <!--            tempor incididunt ut labore et dolore magna aliqua.</p>-->
    <!--        </div>-->

    <!--        <div class="page-login-main animation-slide-right animation-duration-1">-->
    <!--          <div class="brand hidden-md-up">-->
    <!--            <img class="brand-img" src="/static/assets/images/repnode-logo-02-colored.svg" alt="...">-->
    <!--          </div>-->
    <!--          <h3 class="font-size-24">Reset hesla</h3>-->

    <!--          <p v-if="tokenVerified && !success">Zadejte nové heslo</p>-->

    <!--          <new-pass-form-->
    <!--            v-if="tokenVerified"-->
    <!--            @showMessage="showMessage"-->
    <!--            :defaultData="defaultData"/>-->

    <!--          &lt;!&ndash;<p>No account? <a href="register-v2.html">Sign Up</a></p>&ndash;&gt;-->

    <!--          <footer class="page-copyright">-->
    <!--            <p>© 2020 Repnode. All RIGHT RESERVED.</p>-->
    <!--          </footer>-->
    <!--        </div>-->

    <!--      </div>-->
    <!--    </div>-->
    <!--    &lt;!&ndash; End Page &ndash;&gt;-->

    <!-- Page -->
    <div class="page vertical-align text-center" data-animsition-in="fade-in" data-animsition-out="fade-out">>
      <div class="page-content vertical-align-middle animation-slide-top animation-duration-1">
        <div class="panel">
          <div class="panel-body">
            <div class="brand">
              <img class="brand-img" src="/static/assets/images/repnode-n-logo-colored.svg" alt="...">
            </div>

            <alert ref="alert"/>

            <new-pass-form
              v-if="tokenVerified"
              @showMessage="showMessage"
              :defaultData="defaultData"
            />
          </div>
        </div>

        <footer class="page-copyright page-copyright-inverse">
          <!--<p>WEBSITE BY Creation Studio</p>-->
          <p>© 2023. All RIGHT RESERVED.</p>
        </footer>
      </div>
    </div>
    <!-- End Page -->


  </div>
</template>

<script>
import newPassForm from './NewPasswordForm'
import alert       from '../alert'
import Qs          from 'query-string'
import { http }    from '@/http'

export default {
  components: { alert, newPassForm },
  data () {
    return {
      token:         this.$route.params.token,
      tokenVerified: false,
      defaultData:   {},
      success:       false
    }
  },
  methods:    {

    showMessage (data) {
      this.$refs.alert.showMessage(data)
    },

    verifyToken () {
      let callback = (latitude, longitude) => {

        let d = {
          token: this.token
        }

        if (latitude && longitude) {
          d.CurrentLatitude  = latitude
          d.CurrentLongitude = longitude
        }

        let data = Qs.stringify(d)

        http.post(
          `User/VerifyEmail`,
          data,
          {
            headers: {
              'Content-type': 'application/x-www-form-urlencoded'
            }
          }
        )
          /* zpracovani pozadavku */
            .then(response => {
              if (response.status === 200) {
                this.defaultData = response.data.value

                this.tokenVerified = true

                this.$store.commit('setUser', { response: response.data.value })

                http.defaults.headers.appName       = this.$store.getters.urlAppName
                http.defaults.headers.Authorization = this.$store.getters.user.identity.tokenType + ' ' +
                  this.$store.getters.user.identity.accessToken
              }
              else {
                this.tokenVerified = false

                let alertData = {
                  message: 'Bezpečností token není platný',
                  type:    'error'
                }
                this.$refs.alert.showMessage(alertData)
              }
            })

            .catch(e => {
              this.tokenVerified = false

              let alertData = {
                message: 'Bezpečností token není platný',
                type:    'error'
              }
              this.$refs.alert.showMessage(alertData)
            })
      }

      navigator.geolocation.getCurrentPosition((position) => {
        let latitude  = position.coords.latitude,
            longitude = position.coords.longitude

        callback(latitude, longitude)
      }, () => {
        callback(null, null)
      })
    }
  },

  created () {
    this.verifyToken()

    // hack - simulace overeni
    // this.tokenVerified = true
    // this.defaultData = {
    //   id:           1102,
    //   IDtLanguage:  1,
    //   lang:         'CZ',
    //   access_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoic3VwcG9ydEBvcmJpbmV0LmN6IiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwOS8wOS9pZGVudGl0eS9jbGFpbXMvYWN0b3IiOiJybmZpcm1hMSIsIm5iZiI6IjE1MTg2MDE2MDMiLCJleHAiOiIxNTE4Njg4MDAzIn0.-f8sZJsB_TqaPcMVEYndYJWHbfZdVcc94NfmJH1XPdY",
    //   token_type:   'Bearer',
    //   appName:      'rnfirma1'
    // }
    // this.$store.commit('setUser', this.defaultData)

    document.body.classList.add('animsition')
    document.body.classList.add('page-login-v3')
    document.body.classList.add('layout-full')
    document.body.classList.add('page-dark')
    document.body.classList.remove('dashboard')
  }
}
</script>

<style scoped>
@import '../../../assets/login-v2.css';

</style>
